export function isInternalLandingHref(href: string) {
  return /^(\/(?!\/)|#)/.test(href) &&
    !/[\\\s\p{Cc}]/u.test(href) &&
    !/%(?:2f|5c|0[0-9a-f]|1[0-9a-f]|7f)/i.test(href);
}

export function isSafeLandingFooterHref(href: string) {
  if (isInternalLandingHref(href)) return true;
  if (!/^https?:\/\/[^/]/i.test(href) || /[\\\s\p{Cc}]/u.test(href)) return false;

  try {
    const url = new URL(href);
    return Boolean(url.hostname) && !url.username && !url.password;
  } catch {
    return false;
  }
}
